import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

export const Cards = ({ title, value, sx }) => {
    const convertedTitle =
    typeof title === "string" || typeof title === "number"
      ? title
      : String(title ?? "—");

  const convertedValue =
    typeof value === "string" || typeof value === "number"
      ? value
      : String(value ?? "—");

  return (
  <Card
    sx={{
      backgroundColor: '#F8F8F8',
      borderLeft: '5px solid #1A407D',
      borderRadius: '8px',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <CardContent
      sx={{
        padding: '20px 20px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '18px', 
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontSize: '14px',
          fontWeight: 500,
          color: '#1A407D',
        }}
      >
        {convertedTitle}
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontSize: '16px',
          fontWeight: 600,
          color: '#1C252E',
        }}
      >
        {convertedValue}
      </Typography>
    </CardContent>
  </Card>
)};
